import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./HoroscopeList.css";

const HoroscopeDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { url, type, sign, lang: initialLang } = location.state || {};
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [language, setLanguage] = useState(initialLang || "en"); // Default language

  // Fetch horoscope data whenever URL or language changes
  useEffect(() => {
    if (!url) return;

    setLoading(true);
    setError("");
    setResult(null);

    // Dynamically update lang param in the URL
    const urlWithLang = new URL(url);
    urlWithLang.searchParams.set("lang", language);

    fetch(urlWithLang, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`API error: ${res.status}`);
        return res.json();
      })
      .then((data) => setResult(data.response || data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [url, language]);

  // Animated percentage bar
  const StatBar = ({ label, value }) => {
    const [fill, setFill] = useState(0);

    useEffect(() => {
      let start = 0;
      const duration = 800; // ms
      const increment = value / (duration / 16); // ~60fps

      const interval = setInterval(() => {
        start += increment;
        if (start >= value) {
          start = value;
          clearInterval(interval);
        }
        setFill(Math.round(start));
      }, 16);

      return () => clearInterval(interval);
    }, [value]);

    return (
      <div className="horoscope-stat">
        <span className="stat-label">{label}</span>
        <div className="stat-bar">
          <div className="stat-fill" style={{ width: `${fill}%` }}>
            <span className="stat-percent">{fill}%</span>
          </div>
        </div>
      </div>
    );
  };

  const renderResult = () => {
    if (!result) return null;

    if (type === "daily") {
      return (
        <div className="horoscope-card">
          <h2 className="horoscope-title">{sign.name}</h2>
          <p className="horoscope-date">{result.date}</p>
          <p className="horoscope-text">{result.horoscope_data}</p>
        </div>
      );
    } else if (type === "weekly") {
      return (
        <div className="horoscope-card">
          <h2 className="horoscope-title">{sign.name}</h2>
          <p className="horoscope-date">{result.week}</p>
          <p className="horoscope-text">{result.horoscope_data}</p>
        </div>
      );
    } else if (type === "monthly") {
      return (
        <div className="horoscope-card">
          <h2 className="horoscope-title">{sign.name}</h2>
          <p className="horoscope-date">{result.month}</p>
          <p className="horoscope-text">{result.horoscope_data}</p>

          <div className="horoscope-monthly-extra">
            <p><strong>Challenging Days:</strong> {result.challenging_days}</p>
            <p><strong>Standout Days:</strong> {result.standout_days}</p>

            <div className="horoscope-stats">
              <StatBar label="Love" value={result.love} />
              <StatBar label="Finances" value={result.finances} />
              <StatBar label="Status" value={result.status} />
              <StatBar label="Career" value={result.career} />
              <StatBar label="Travel" value={result.travel} />
              <StatBar label="Family" value={result.family} />
              <StatBar label="Friends" value={result.friends} />
              <StatBar label="Health" value={result.health} />
            </div>

            <p className="total-score">
              <strong>Total Score:</strong> {result.total}%
            </p>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="horoscope-detail-page">
      <div className="container">
        <div className="horoscope-detail">
          <div className="horoscope-detail-top">
            <button className="horoscope-back-btn" onClick={() => navigate(-1)}>
              &larr; Back
            </button>

            {/* Language selector */}
            <div className="horoscope-lang-selector">
              <label>Language: </label>
              <select value={language} onChange={(e) => setLanguage(e.target.value)}>
                <option value="en">English</option>
                <option value="hi">Hindi</option>
                <option value="ta">Tamil</option>
                <option value="te">Telugu</option>
                <option value="ka">Kannada</option>
                <option value="ml">Malayalam</option>
                <option value="be">Bengali</option>
                <option value="gr">Gujarati</option>
                <option value="mr">Marathi</option>
              </select>
            </div>
          </div>

          {loading && <p className="horoscope-loading">Loading...</p>}
          {error && <p className="horoscope-error">{error}</p>}

          {renderResult()}
        </div>
      </div>
    </div>
  );
};

export default HoroscopeDetail;
